import { render, staticRenderFns } from "./modal-confirmacao-cirurgica.vue?vue&type=template&id=01743d04&scoped=true"
import script from "./modal-confirmacao-cirurgica.vue?vue&type=script&lang=ts"
export * from "./modal-confirmacao-cirurgica.vue?vue&type=script&lang=ts"
import style0 from "./modal-confirmacao-cirurgica.vue?vue&type=style&index=0&id=01743d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01743d04",
  null
  
)

export default component.exports